module.exports = __webpack_public_path__ + "static/media/ic_sec_consumer_defensive.61163802.svg";